import axios from '@/axios'

export default {
  sendMessage(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/contact`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
